import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { PreLoader } from "../../subcomponents/Preloader";
import { textStyle } from "../../styles/Style";
import "../../../components/styles/popupStyle.css";
import InfoIcon from "@mui/icons-material/Info";
import {
  checkData,
  deleteItem,
  fillAutocompleteValues,
  getNextPostTypeNumber,
  isPostTypeNumberUsed,
  updateData,
} from "../../actions/actionItems";
import AlertComponent from "../../subcomponents/AlertComponent";
import DraggableItemList from "../../subcomponents/DNDComponent";
import { postTypesTooltip } from "../../../constants/TooltipInformation";
import { RoomPropertyEnum } from "../../../constants/NavbarList";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import {
  validateIntegerLength,
  validateString,
  validationLength,
  validationType,
} from "../../actions/validations";
import {
  versaFieldErrors,
  versaFieldHelperText,
} from "../../../constants/VersaHelperTexts";
import { tooltipComponent } from "../../subcomponents/tooltipComponent";
import {
  characteristicsList,
  postTypesCategoryList,
} from "../../../constants/PostTypes";
import { buttonValues, DNDFieldsEnum } from "../../../constants/Types";
import { ClearButton } from "../../subcomponents/ClearButton";
import { payloadConstants } from "../../../constants/defaultValues";
import { removeSampleTestArray } from "../../actions/cleanup";
import { CopyButton } from "../../subcomponents/CopyButton";
import useScrollToTop from "../../hooks/useScrollToTop";
import {
  postTypeTaxDetailPayload,
  readPostTypeTaxDetailsFromRecord,
} from "../common/postTypeHelpers";

type groupingFunctionalityTypes = ["none", "fixed", "percentage", "open"];

const TaxPostTypes = ({
  data,
  fieldValues,
}: {
  data: any;
  fieldValues?: any;
}) => {
  const [departmentName, setDepartmentName] = useState<string | null>(null);
  const [departmentList, setDepartmentList] = useState<string[]>([]);
  const [categoryName, setCategoryName] = useState<string | null>(null);
  const [categoryList, setCategoryList] = useState<string[]>([]);
  const [postTypeNumber, setPostTypeNumber] = useState<number | null>(null);
  const [postTypeName, setPostTypeName] = useState<string | null>(null);
  const [nameError, setNameError] = useState<boolean>(false);
  const [numberError, setNumberError] = useState<boolean>(false);
  const [credit, setCredit] = useState<boolean>(false);
  const [deposit, setDeposit] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [characteristics, setCharacteristics] = useState<string | null>(null);
  const [postTypeCategory, setPostTypeCategory] = useState<string | null>(null);
  const [defaultAmount, setDefaultAmount] = useState<number | null>(null);
  const [amountError, setAmountError] = useState<boolean>(false);
  const [buildingList, setBuildingList] = useState<string[]>([]);
  const [defaultBuilding, setDefaultBuilding] = useState<string | null>(null);
  const [floorLimit, setFloorLimit] = useState<number | null>(null);
  const [ceilingLimit, setCeilingLimit] = useState<number | null>(null);
  const [groupingFunctionality, setGroupingFunctionality] =
    useState<groupingFunctionalityTypes | null>(null);
  const [requireReference, setRequireReference] = useState<boolean>(false);
  const [requireComment, setRequireComment] = useState<boolean>(false);
  const [restrictReservationPost, setRestrictReservationPost] =
    useState<boolean>(false);
  const [requirePasscode, setRequirePasscode] = useState<boolean>(false);
  const [defaultFolio, setDefaultFolio] = useState<number>(1);
  const [defaultMasterFolio, setDefaultMasterFolio] = useState<number | null>(
    null,
  );
  const [folioError, setFolioError] = useState<boolean>(false);
  const [masterFolioError, setMasterFolioError] = useState<boolean>(false);
  const [ledgerNumber, setLedgerNumber] = useState<string | null>(null);
  const [ledgerError, setLedgerError] = useState<boolean>(false);
  const [ledgerOffsetNumber, setLedgerOffsetNumber] = useState<number | null>(
    null,
  );
  const [sageExtractNumber, setSageExtractNumber] = useState<number | null>(
    null,
  );
  const [revenueBracket, setRevenueBracket] = useState<number | null>(null);
  const [commisionFlat, setCommisionFlat] = useState<number | null>(null);
  const [commisionPercentage, setCommisionPercentage] = useState<number | null>(
    null,
  );
  const [chargedToCondoOwner, setChargedToCondoOwner] =
    useState<boolean>(false);
  const [useCommision, setUseCommision] = useState<boolean>(false);
  const [commisionable, setCommisionable] = useState<boolean>(false);
  const [postTypesInformation, setPostTypesInformation] = useState<any>(null);
  const giftCardList: string[] = [];
  const [giftCardFunctionality, setGiftCardFunctionality] =
    useState<boolean>(false);
  const [giftCard, setGiftCard] = useState<boolean>(false);
  const [roomRevenue, setRoomRevenue] = useState<boolean>(false);
  const [food, setFood] = useState<boolean>(false);
  const [beverage, setBeverage] = useState<boolean>(false);
  const [roomRental, setRoomRental] = useState<boolean>(false);
  const [resource, setResource] = useState<boolean>(false);
  const [other, setOther] = useState<boolean>(false);
  const [taxList, setTaxList] = useState<string[]>([]);
  const [selectedTax, setSelectedTax] = useState<string[]>([]);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [openAccordion, setOpenAccordion] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string | number | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [lastUpdatedRecord, setLastUpdatedRecord] = useState<any>(null);
  const { topRef, scrollToTop } = useScrollToTop();

  const commonPostTypesList = Array.isArray(
    fieldValues?.[RoomPropertyEnum.postTypes],
  )
    ? fieldValues[RoomPropertyEnum.postTypes]
    : fieldValues?.[RoomPropertyEnum.postTypes]
      ? [fieldValues[RoomPropertyEnum.postTypes]]
      : [];

  const suggestNextPostTypeNumber = () => {
    setPostTypeNumber(
      getNextPostTypeNumber(postTypesInformation, commonPostTypesList),
    );
  };

  const isDuplicatePostTypeNumber = (
    number: number | string | null | undefined,
    excludeId?: string | number | null,
  ) => {
    return isPostTypeNumberUsed(number, [
      {
        items: Array.isArray(postTypesInformation) ? postTypesInformation : [],
        excludeId,
      },
      { items: commonPostTypesList },
    ]);
  };

  const postTypePayload = {
    postTypeNumber,
    departmentName,
    categoryName,
    postTypeName,
    isActive,
    isCredit: credit,
    isDeposit: deposit,
    characteristics:
      characteristics ??
      payloadConstants[RoomPropertyEnum.postTypes].CHARACTERISTICS,
    postTypeCategory:
      postTypeCategory ??
      payloadConstants[RoomPropertyEnum.postTypes].POST_TYPE_CATEGORY,
    defaultAmount:
      defaultAmount ??
      payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_AMOUNT,
    floorLimit:
      floorLimit ?? payloadConstants[RoomPropertyEnum.postTypes].FLOOR_LIMIT,
    ceilingLimit:
      ceilingLimit ??
      payloadConstants[RoomPropertyEnum.postTypes].CEILING_LIMIT,
    groupingFunctionality: groupingFunctionality ?? [],
    isRequiredReference: requireReference ?? false,
    isRestrictReservationPost: restrictReservationPost ?? false,
    isRequireComment: requireComment ?? false,
    isPasscode: requirePasscode ?? false,
    defaultFolio:
      defaultFolio ??
      payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_FOLIO,
    defaultMasterFolio:
      defaultMasterFolio ??
      payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_MASTER_FOLIO,
    // defaultBuilding,
    glNumber:
      ledgerNumber ??
      payloadConstants[RoomPropertyEnum.postTypes].LEDGER_NUMBER,
    glOffsetNumber:
      ledgerOffsetNumber ??
      payloadConstants[RoomPropertyEnum.postTypes].LEDGER_NUMBER,
    sageExtractNumber:
      sageExtractNumber ??
      payloadConstants[RoomPropertyEnum.postTypes].SAGE_EXTRACT_NUMBER,
    extractRevenueBracket:
      revenueBracket ??
      payloadConstants[RoomPropertyEnum.postTypes].EXTRACT_REVENUE_BRACKET,
    isCommisionable: commisionable ?? false,
    commissionFlat: commisionFlat ?? false,
    isChargedToCondoOwner: chargedToCondoOwner ?? false,
    isCommissionPecentage: useCommision ?? false,
    commissionPercentage:
      commisionPercentage ??
      payloadConstants[RoomPropertyEnum.postTypes].COMMISSIONPERCENTAGE,
    ...postTypeTaxDetailPayload({
      giftCardFunctionality,
      giftCard,
      selectedTax,
      roomRevenue,
      resource,
      roomRental,
      food,
      beverage,
      other,
    }),
  };

  const addPostTypes = () => {
    if (!validateInput()) return;
    if (!postTypeNumber || postTypeNumber === null) {
      setNumberError(true);
      return;
    }
    if (!postTypeName || postTypeName === null) {
      setNameError(true);
      return;
    }
    if (!departmentName || departmentName === null) {
      setAlertMessage("Enter the department name");
      setAlertType("error");
      setOpenAlert(true);
      setOpenAccordion(true);
      return;
    }
    if (isDuplicatePostTypeNumber(postTypeNumber)) {
      setAlertMessage(
        "Post type number already exists in Tax Post Types or Post Types",
      );
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setPostTypesInformation((prev: any) => {
      return updateData(
        Array.isArray(prev)
          ? [
              ...prev,
              {
                id: prev.length + 1,
                ...postTypePayload,
              },
            ]
          : [
              {
                id: 1,
                ...postTypePayload,
              },
            ],
      );
    });
    setLastUpdatedRecord(postTypePayload);
    editPostTypesInformation(null);
    setEditClicked(false);
    suggestNextPostTypeNumber();
    setOpenAccordion(false);
  };

  const resetPostTypeForm = () => {
    setDepartmentName(null);
    setCategoryName(null);
    setPostTypeNumber(null);
    setPostTypeName(null);
    setNameError(false);
    setNumberError(false);
    setCredit(false);
    setDeposit(false);
    setIsActive(true);
    setCharacteristics(null);
    setPostTypeCategory(null);
    setDefaultAmount(null);
    setAmountError(false);
    setDefaultBuilding(null);
    setFloorLimit(null);
    setCeilingLimit(null);
    setGroupingFunctionality(null);
    setRequireReference(false);
    setRequireComment(false);
    setRestrictReservationPost(false);
    setRequirePasscode(false);
    setDefaultFolio(1);
    setDefaultMasterFolio(null);
    setFolioError(false);
    setMasterFolioError(false);
    setLedgerNumber(null);
    setLedgerError(false);
    setLedgerOffsetNumber(null);
    setSageExtractNumber(null);
    setRevenueBracket(null);
    setCommisionFlat(null);
    setCommisionPercentage(null);
    setChargedToCondoOwner(false);
    setUseCommision(false);
    setCommisionable(false);
    setGiftCardFunctionality(false);
    setGiftCard(false);
    setRoomRevenue(false);
    setFood(false);
    setBeverage(false);
    setRoomRental(false);
    setResource(false);
    setOther(false);
    setSelectedTax([]);
  };

  const editPostTypesInformation = (list: any) => {
    if (!list) {
      setSelectedId(null);
      setEditClicked(false);
      resetPostTypeForm();
      suggestNextPostTypeNumber();
      return;
    }
    setOpenAccordion(true);
    list?.id != null && setSelectedId(list.id);
    setEditClicked(true);
    setPostTypeNumber(
      list?.postTypeNumber != null ? Number(list.postTypeNumber) : null,
    );
    setDepartmentName(list?.departmentName);
    setCategoryName(list?.categoryName);
    setPostTypeName(list?.postTypeName);
    setIsActive(list ? list.isActive : true);
    setCredit(list ? list.isCredit : false);
    setDeposit(list ? list.isDeposit : false);
    setCharacteristics(list?.characteristics);
    setPostTypeCategory(list?.postTypeCategory);
    setDefaultAmount(list?.defaultAmount);
    setFloorLimit(list?.floorLimit);
    setCeilingLimit(list?.ceilingLimit);
    setDefaultBuilding(list?.defaultBuilding);
    setGroupingFunctionality(list?.groupingFunctionality);
    setRequireReference(list ? list.isRequiredReference : false);
    setRestrictReservationPost(list ? list.isRestrictReservationPost : false);
    setRequireComment(list ? list.isRequireComment : false);
    setRequirePasscode(list ? list.isPasscode : false);
    setDefaultFolio(list?.defaultFolio);
    setDefaultMasterFolio(list?.defaultMasterFolio);
    setLedgerNumber(list?.glNumber != null ? String(list.glNumber) : null);
    setLedgerOffsetNumber(list?.glOffsetNumber);
    setSageExtractNumber(list?.sageExtractNumber);
    setRevenueBracket(list?.extractRevenueBracket);
    setCommisionable(list ? list.isCommisionable : false);
    setCommisionFlat(list?.commissionFlat);
    setChargedToCondoOwner(list ? list.isChargedToCondoOwner : false);
    setUseCommision(list ? list.isCommissionPecentage : false);
    setCommisionPercentage(list?.commissionPercentage);
    const taxDetails = readPostTypeTaxDetailsFromRecord(list);
    setGiftCardFunctionality(taxDetails.giftCardFunctionality);
    setGiftCard(taxDetails.giftCard);
    setSelectedTax(taxDetails.selectedTax);
    setRoomRevenue(taxDetails.roomRevenue);
    setFood(taxDetails.food);
    setBeverage(taxDetails.beverage);
    setRoomRental(taxDetails.roomRental);
    setResource(taxDetails.resource);
    setOther(taxDetails.other);
  };

  const updatePostType = () => {
    if (!validateInput()) return;
    if (!postTypeNumber || postTypeNumber === null) {
      setNumberError(true);
      return;
    }
    if (!postTypeName || postTypeName === null) {
      setNameError(true);
      return;
    }
    if (!departmentName || departmentName === null) {
      setAlertMessage("Enter the department name");
      setAlertType("error");
      setOpenAlert(true);
      setOpenAccordion(true);
      return;
    }
    if (isDuplicatePostTypeNumber(postTypeNumber, selectedId)) {
      setAlertMessage(
        "Post type number already exists in Tax Post Types or Post Types",
      );
      setAlertType("error");
      setOpenAlert(true);
      return;
    }
    setPostTypesInformation((prev: any) =>
      Array.isArray(prev)
        ? prev.map((item: any) => {
            if (String(item.id) === String(selectedId)) {
              return {
                ...item,
                ...postTypePayload,
              };
            }
            return item;
          })
        : prev,
    );
    editPostTypesInformation(null);
    setEditClicked(false);
    setSelectedId(null);
    suggestNextPostTypeNumber();
    setAlertMessage(`${RoomPropertyEnum.postTypes} updated successfully`);
    setAlertType("success");
    setOpenAlert(true);
    setOpenAccordion(false);
  };

  const deletePostTypesInformation = (id: number) => {
    setPostTypesInformation(deleteItem(postTypesInformation, id));
  };

  const validateInput = () => {
    setNumberError(false);
    setNameError(false);
    setAmountError(false);
    setFolioError(false);
    setMasterFolioError(false);
    setLedgerError(false);
    let isValid = true;
    if (
      postTypeNumber &&
      !validateIntegerLength(postTypeNumber, validationLength.postTypeNumber)
    ) {
      setNumberError(true);
      isValid = false;
    }
    if (
      postTypeName &&
      !validateString(
        postTypeName,
        validationLength.postTypeName,
        validationType.OTHER,
      )
    ) {
      setNameError(true);
      isValid = false;
    }
    if (
      defaultAmount &&
      !validateIntegerLength(defaultAmount, validationLength.defaultAmount)
    ) {
      setAmountError(true);
      isValid = false;
    }
    if (
      defaultFolio &&
      !validateIntegerLength(defaultFolio, validationLength.defaultFolio)
    ) {
      setFolioError(true);
      isValid = false;
    }
    if (
      defaultMasterFolio &&
      !validateIntegerLength(
        defaultMasterFolio,
        validationLength.defaultMasterFolio,
      )
    ) {
      setMasterFolioError(true);
      isValid = false;
    }
    if (
      ledgerNumber &&
      !validateString(
        ledgerNumber,
        validationLength.ledgerNumber,
        validationType.OTHER,
      )
    ) {
      setLedgerError(true);
      isValid = false;
    }
    return isValid;
  };

  useEffect(() => {
    data(postTypesInformation);
    if (!editClicked && selectedId == null) {
      suggestNextPostTypeNumber();
    }
    if (editClicked) {
      setSelectedId(
        checkData(postTypesInformation, selectedId) ? selectedId : null,
      );
    }
  }, [postTypesInformation]);

  useEffect(() => {
    validateInput();
  }, [
    postTypeNumber,
    postTypeName,
    defaultAmount,
    defaultFolio,
    defaultMasterFolio,
    ledgerNumber,
  ]);

  useEffect(() => {
    if (numberError || nameError || Boolean(selectedId)) {
      setOpenAccordion(true);
    }
  }, [numberError, nameError, selectedId]);

  useEffect(() => {
    if (fieldValues) {
      setPostTypesInformation(
        Array.isArray(fieldValues[RoomPropertyEnum.taxPostTypes])
          ? fieldValues[RoomPropertyEnum.taxPostTypes]
          : fieldValues[RoomPropertyEnum.taxPostTypes]
            ? [fieldValues[RoomPropertyEnum.taxPostTypes]]
            : null,
      );
      setDepartmentList(
        fillAutocompleteValues(
          fieldValues[RoomPropertyEnum.department],
          DNDFieldsEnum.DEPARTMENTCODE,
          "",
        ),
      );
      setCategoryList(
        fillAutocompleteValues(
          fieldValues[RoomPropertyEnum.category],
          DNDFieldsEnum.CATEGORYCODE,
          "",
        ),
      );
      setTaxList(
        fillAutocompleteValues(
          fieldValues[RoomPropertyEnum.taxes],
          DNDFieldsEnum.TAXCODE,
          "",
        ),
      );
      setBuildingList(
        fillAutocompleteValues(
          fieldValues[RoomPropertyEnum.buildingCodes],
          DNDFieldsEnum.BUILDINGCODE,
          DNDFieldsEnum.BUILDINGNAME,
        ),
      );
    }
  }, []);

  const postTypeNumberHelperText = numberError
    ? postTypeNumber === null || postTypeNumber === undefined
      ? versaFieldErrors.required
      : versaFieldErrors.taxPostType.postTypeNumber
    : versaFieldHelperText.taxPostType.postTypeNumber;

  const postTypeNameHelperText = nameError
    ? !postTypeName
      ? versaFieldErrors.required
      : versaFieldErrors.taxPostType.postTypeName
    : versaFieldHelperText.taxPostType.postTypeName;

  const defaultAmountHelperText = amountError
    ? versaFieldErrors.taxPostType.defaultAmount
    : versaFieldHelperText.taxPostType.defaultAmount;

  const defaultFolioHelperText = folioError
    ? versaFieldErrors.taxPostType.defaultFolio
    : versaFieldHelperText.taxPostType.defaultFolio;

  const defaultMasterFolioHelperText = masterFolioError
    ? versaFieldErrors.taxPostType.defaultMasterFolio
    : versaFieldHelperText.taxPostType.defaultMasterFolio;

  const ledgerNumberHelperText = ledgerError
    ? versaFieldErrors.taxPostType.ledgerNumber
    : versaFieldHelperText.taxPostType.ledgerNumber;

  return (
    <Stack direction="column" gap="10px">
      <div ref={topRef} />
      <Stack direction="column" width="100%">
        <Paper
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "20px",
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            gap="10px"
            mb={4}
          >
            <Typography variant="h6" component="div" sx={textStyle}>
              Tax Post Types Information
              <Tooltip title={tooltipComponent(postTypesTooltip.header)}>
                <InfoIcon fontSize="small" />
              </Tooltip>
            </Typography>
            <Stack direction="row" gap="10px" justifyContent="space-between">
              {editClicked && (
                <ClearButton
                  click={() => {
                    editPostTypesInformation(null);
                    setSelectedId(null);
                  }}
                />
              )}
              {lastUpdatedRecord && (
                <CopyButton
                  click={() => {
                    editPostTypesInformation(lastUpdatedRecord);
                  }}
                />
              )}
            </Stack>
          </Stack>
          <Accordion
            expanded={openAccordion}
            onChange={() => setOpenAccordion(!openAccordion)}
          >
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">Post Type Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="column" gap="20px">
                <Stack
                  className="form-two-col-row"
                  direction="row"
                  width="100%"
                  gap="20px"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Department
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.department)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <Autocomplete
                      id="departmentName"
                      disablePortal
                      options={removeSampleTestArray(departmentList)}
                      sx={{ width: "100%" }}
                      disabled={!departmentList}
                      value={departmentName ?? ""}
                      onChange={(e: any) =>
                        setDepartmentName(e.target.innerText)
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Department" />
                      )}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Category
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.category)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <Autocomplete
                      id="categoryName"
                      disablePortal
                      options={removeSampleTestArray(categoryList)}
                      sx={{ width: "100%" }}
                      disabled={!categoryList}
                      value={categoryName ?? ""}
                      onChange={(e: any) => setCategoryName(e.target.innerText)}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Category" />
                      )}
                    />
                  </Stack>
                </Stack>
                <Stack
                  className="form-two-col-row"
                  direction="row"
                  width="100%"
                  gap="20px"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Post Type Number
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.postTypeNumber,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="postTypeNumber"
                      variant="outlined"
                      placeholder="Post Type Number"
                      type="number"
                      error={numberError}
                      helperText={postTypeNumberHelperText}
                      value={postTypeNumber ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        if (e.target.value > 0) {
                          setPostTypeNumber(Number(e.target.value));
                        }
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Post Type Name
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.postTypeName)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="postTypeName"
                      variant="outlined"
                      placeholder="Post Type Name"
                      error={nameError}
                      helperText={postTypeNameHelperText}
                      value={postTypeName ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setPostTypeName(e.target.value);
                      }}
                    />
                  </Stack>
                </Stack>
                <Stack
                  className="form-checkbox-row form-two-col-row"
                  direction="row"
                  width="100%"
                  gap="20px"
                  flexWrap="wrap"
                >
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="credit"
                          checked={credit}
                          onChange={(e: any) => setCredit(e.target.checked)}
                        />
                      }
                      label="Credit ?"
                    />
                    <Tooltip title={tooltipComponent(postTypesTooltip.credit)}>
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="deposit"
                          checked={deposit}
                          onChange={(e: any) => setDeposit(e.target.checked)}
                        />
                      }
                      label="Deposit ?"
                    />
                    <Tooltip title={tooltipComponent(postTypesTooltip.deposit)}>
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">Additional Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="column" gap="20px">
                <Stack
                  className="form-two-col-row"
                  direction="row"
                  width="100%"
                  gap="20px"
                  alignItems="center"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Characteristics
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.characteristics,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <Autocomplete
                      id="characteristics"
                      disablePortal
                      options={characteristicsList}
                      value={characteristics ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) =>
                        setCharacteristics(e.target.innerText)
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Characteristics" />
                      )}
                    />
                  </Stack>

                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Post Type Category
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.postTypeCategory,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <Select
                      id="postTypeCategory"
                      value={postTypeCategory ?? ""}
                      onChange={(e: any) => setPostTypeCategory(e.target.value)}
                      sx={{ width: "100%" }}
                    >
                      {postTypesCategoryList.map((payment, index) => (
                        <MenuItem value={payment} key={index}>
                          {payment}
                        </MenuItem>
                      ))}
                    </Select>
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Default Building
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.defaultBuilding,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <Autocomplete
                      id="defaultBuilding"
                      disablePortal
                      sx={{ width: "100%" }}
                      options={removeSampleTestArray(buildingList)}
                      disabled={!buildingList}
                      value={defaultBuilding ?? ""}
                      onChange={(e: any) =>
                        setDefaultBuilding(e.target.innerText)
                      }
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Default Building" />
                      )}
                    />
                  </Stack>
                </Stack>

                <Stack
                  className="form-two-col-row"
                  direction="row"
                  gap="20px"
                  width="100%"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Default Amount
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.defaultAmount)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="defaultAmount"
                      variant="outlined"
                      placeholder="Default Amount ?"
                      helperText={defaultAmountHelperText}
                      error={amountError}
                      type="number"
                      sx={{ width: "100%" }}
                      value={defaultAmount ?? ""}
                      onChange={(e: any) => {
                        setDefaultAmount(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Floor Limit
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.floorLimit)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="floorLimit"
                      variant="outlined"
                      placeholder="Floor Limit"
                      helperText={postTypesTooltip.floorLimit}
                      value={floorLimit ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setFloorLimit(
                          e.target.value > 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Ceiling Limit
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.ceilingLimit)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="ceilingLimit"
                      variant="outlined"
                      placeholder="Ceiling Limit"
                      helperText={postTypesTooltip.ceilingLimit}
                      value={ceilingLimit ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setCeilingLimit(
                          e.target.value > 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  className="form-checkbox-row form-two-col-row"
                  direction="row"
                  gap="20px"
                  width="100%"
                  flexWrap="wrap"
                >
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="requireReference"
                          checked={requireReference}
                          onChange={(e: any) =>
                            setRequireReference(e.target.checked)
                          }
                        />
                      }
                      label="Require reference ?"
                    />
                    <Tooltip
                      title={tooltipComponent(
                        postTypesTooltip.requireReference,
                      )}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="requireComment"
                          checked={requireComment}
                          onChange={(e: any) =>
                            setRequireComment(e.target.checked)
                          }
                        />
                      }
                      label="Require comment ?"
                    />
                    <Tooltip
                      title={tooltipComponent(postTypesTooltip.requireComment)}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="restrictReservationPost"
                          checked={restrictReservationPost}
                          onChange={(e: any) =>
                            setRestrictReservationPost(e.target.checked)
                          }
                        />
                      }
                      label="Restrict reservation post ?"
                    />
                    <Tooltip
                      title={tooltipComponent(
                        postTypesTooltip.restrictReservationPost,
                      )}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="requirePasscode"
                          checked={requirePasscode}
                          onChange={(e: any) =>
                            setRequirePasscode(e.target.checked)
                          }
                        />
                      }
                      label="Passcode ?"
                    />
                    <Tooltip title={""}>
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="chargedToCondoOwner"
                          checked={chargedToCondoOwner}
                          onChange={(e: any) =>
                            setChargedToCondoOwner(e.target.checked)
                          }
                        />
                      }
                      label="Charged to condo owner ?"
                    />
                    <Tooltip
                      title={tooltipComponent(
                        postTypesTooltip.chargedToCondoOwner,
                      )}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="useCommision"
                          checked={useCommision}
                          onChange={(e: any) =>
                            setUseCommision(e.target.checked)
                          }
                        />
                      }
                      label="Use commision ?"
                    />
                    <Tooltip
                      title={tooltipComponent(postTypesTooltip.useCommission)}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                  <Stack
                    direction="row"
                    width="max-content"
                    height="max-content"
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="commisionable"
                          checked={commisionable}
                          onChange={(e: any) =>
                            setCommisionable(e.target.checked)
                          }
                        />
                      }
                      label="Commisionable ?"
                    />
                    <Tooltip
                      title={tooltipComponent(postTypesTooltip.commissionable)}
                    >
                      <InfoIcon fontSize="small" />
                    </Tooltip>
                  </Stack>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ArrowDropDownIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography component="span">Folio Details</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="column" gap="20px">
                <Stack
                  className="form-two-col-row"
                  direction="row"
                  gap="20px"
                  width="100%"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Default Folio
                      <Tooltip
                        title={tooltipComponent(postTypesTooltip.defaultFolio)}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="defaultFolio"
                      variant="outlined"
                      placeholder="Default Folio"
                      type="number"
                      error={folioError}
                      helperText={defaultFolioHelperText}
                      value={defaultFolio ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setDefaultFolio(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Default Master Folio
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.defaultMasterFolio,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="defaultMasterFolio"
                      variant="outlined"
                      placeholder="Default Master Folio"
                      type="number"
                      helperText={defaultMasterFolioHelperText}
                      error={masterFolioError}
                      value={defaultMasterFolio ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setDefaultMasterFolio(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Extract Revenue Bracket
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.extractRevenueBucket,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="extractRevenueBucket"
                      variant="outlined"
                      placeholder="Extract Revenue Bracket"
                      type="number"
                      helperText={postTypesTooltip.extractRevenueBucket}
                      value={revenueBracket ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setRevenueBracket(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                </Stack>

                <Stack
                  className="form-two-col-row"
                  direction="row"
                  gap="20px"
                  width="100%"
                >
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      General Ledger Number
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.generalLedgerOffsetNumber,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      variant="outlined"
                      placeholder="General Ledger Number"
                      helperText={ledgerNumberHelperText}
                      error={ledgerError}
                      sx={{ width: "100%" }}
                      value={ledgerNumber ?? ""}
                      onChange={(e: any) => {
                        setLedgerNumber(e.target.value);
                      }}
                    />
                  </Stack>
                  {/* <TextField
                    variant="outlined"
                    placeholder="General Ledger Offset Number"
                    helperText={postTypesTooltip.generalLedgerOffsetNumber}
                    value={ledgerOffsetNumber ?? ""}
                    onChange={(e: any) => {
                      setLedgerOffsetNumber(e.target.value);
                    }}
                  /> */}
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Sage Extract Number
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.sageExtractNumber,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="sageExtractNumber"
                      variant="outlined"
                      placeholder="Sage Extract Number"
                      type="number"
                      helperText={postTypesTooltip.sageExtractNumber}
                      value={sageExtractNumber ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setSageExtractNumber(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Commission Flat
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.commissionFlat,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="commisionFlat"
                      variant="outlined"
                      placeholder="Commision Flat"
                      type="number"
                      helperText={postTypesTooltip.commissionFlat}
                      value={commisionFlat ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setCommisionFlat(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                  <Stack direction="column" width="100%" gap="5px">
                    <FormLabel component="legend">
                      Commission Percentage
                      <Tooltip
                        title={tooltipComponent(
                          postTypesTooltip.commissionPercentage,
                        )}
                      >
                        <InfoIcon fontSize="small" />
                      </Tooltip>
                    </FormLabel>
                    <TextField
                      id="commisionPercentage"
                      variant="outlined"
                      placeholder="Commision Percentage"
                      type="number"
                      helperText={postTypesTooltip.commissionPercentage}
                      value={commisionPercentage ?? ""}
                      sx={{ width: "100%" }}
                      onChange={(e: any) => {
                        setCommisionPercentage(
                          e.target.value >= 0 ? e.target.value : null,
                        );
                      }}
                    />
                  </Stack>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>

          <Stack direction="row" width="100%" gap="2px">
            <FormControlLabel
              control={
                <Switch
                  checked={isActive}
                  onChange={() => setIsActive(!isActive)}
                />
              }
              label="Active?"
            />
            <Tooltip title={tooltipComponent(postTypesTooltip.active)}>
              <InfoIcon fontSize="small" />
            </Tooltip>
          </Stack>

          <Stack direction="row" width="100%" justifyContent="flex-end">
            <Button
              variant="contained"
              sx={{
                cursor: "pointer",
                border: "1px solid gray",
                borderRadius: "10px",
                background: "darkgreen",
                color: "white",
              }}
              onClick={selectedId ? updatePostType : addPostTypes}
              id="updatePostTypesInformation"
            >
              {selectedId ? buttonValues.UPDATE : buttonValues.ADD} Post Types
              Information
            </Button>
          </Stack>
          <Stack direction="column" gap="10px" mt={4}>
            <Typography variant="h6">
              Post Types Information Available
            </Typography>
            <Typography variant="body2" sx={{ color: "red", fontWeight: 800 }}>
              Do not use sample data. Those are for demo purposes only!
            </Typography>
            <Stack direction="column" gap="10px">
              {postTypesInformation ? (
                <DraggableItemList
                  itemData={postTypesInformation}
                  onOrderUpdate={(order) => setPostTypesInformation(order)}
                  onEdit={(info) => {
                    editPostTypesInformation(info);
                    scrollToTop();
                  }}
                  onDelete={(id) => deletePostTypesInformation(id)}
                  code={DNDFieldsEnum.POSTTYPECODE}
                  name={DNDFieldsEnum.POSTTYPENAME}
                />
              ) : (
                <Typography variant="body2">
                  No Post Types Information Available
                </Typography>
              )}
            </Stack>
          </Stack>
        </Paper>
      </Stack>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        alertOpen={openAlert}
        closeAlert={() => setOpenAlert(false)}
      />
    </Stack>
  );
};

export default TaxPostTypes;
